import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Button, Card, Col, Row} from "react-bootstrap";
import storage from "../../../Storage";
import RangeCredit from "../../Components/Game/Addons";
import {gameCoin} from "../../../actions/gameCoin";
import {setPlay} from "../../../actions/gamePlay";
import {setWallet} from "../../../actions/gameWallet";
import {Event, __, forceSatoshiFormat, isValidNumber, sendNotfication, wait, isMobile, playAudio} from "../../../Helper";
import C from "../../../Constant";
import { FiAlertCircle } from "react-icons/fi";

class Bet extends React.Component {
    _isMounted = false;
    constructor (props){
        super(props);
        this.state = {
            engine: this.props.engine,
            started: false,
            bet: 'manual',
            isLogged: storage.getKey('logged') !== null ? true : false,
            buttonText: 'BET',
            amount: forceSatoshiFormat(storage.getKey('lam') ? storage.getKey('lam') : .00000010),
            inputDisabled: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleBet = this.handleBet.bind(this);
    }

    componentDidMount(){
        if(this._isMounted){
            let { engine } = this.state;

            wait(300).then(() => {
                if(isMobile()){
                    this.setState({ padding: 'p-1'})
                }
            });
            
            this.props.gameCoin();
            engine.on(C.PLAY_THREE_CARD_MONTE, (data) => this.play(data));
            engine.on(C.BUSTED_THREE_CARD_MONTE, (data) => this.busted(data));
            engine.on(C.ERROR_THREE_CARD_MONTE, (data) => this.error(data));
            engine.on("stop_playing", () => this.stopManual());
        }
    }
    
    componentWillMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        let { engine } = this.state;
        engine.init = false;
        this._isMounted = false;
    }
    
    stopManual() {
        if(this._isMounted){
            this.setState({ started: false, buttonText: 'BET', inputDisabled: false });
        }
    }

    error(data) {
        if(this._isMounted){
            sendNotfication(data.message, 'info', 'top-center');

            if(data.code === 'credit')
                this.props.setWallet(true, data.uid);

            this.setState({inputDisabled: false, started: false, buttonText: 'BET'});
        }
    }

    play(data){
        if(this._isMounted){
            playAudio('dice2.mp3')
        }
    }

    busted(data){
        if(this._isMounted){
            this.setState({ inputDisabled: false });
        }
    }

    placeBet(){
        if(this._isMounted)
        {
            let { engine, amount } = this.state;
            wait(500)
                .then(() => {
                    engine.init = true;
                    engine.amount = amount;
                    engine.coin = this.props.coin;
                    engine.start();
                });
        }
    }

    isCorrectBet(amount){
        if(this._isMounted)
        {
            if(__.isUndefined(amount)) return;
            
            if(amount === '')
                return false;

            if(!isValidNumber(amount))
                return false;
            
            if(parseFloat(amount) <= 0){
                this.setState({ amount: forceSatoshiFormat(0.00000010) });
            }
            else {
                amount = Math.min(parseFloat(storage.getKey('credit')), parseFloat(amount));
                this.setState({ amount: forceSatoshiFormat(amount) });
            }
            return true;
        }        
    }

    handleBet(e){
        if(this._isMounted)
        {
            e.preventDefault();

            let { isLogged, amount } = this.state;

           // Check User
            if(!isLogged){
               return Event.emit('showAuthModal', true);
            }

            // Check is Correct Bet
            if(!this.isCorrectBet(amount))
                return false;

            this.setState({inputDisabled: true});
            this.placeBet();
        }
    }

    handleInputChange(event){
        if(this._isMounted){
            let target = event.target;
            let value  = target.value;
            let name   = target.name;

            if(name === 'amount'){
                this.setState({amount:value})
                if(!isValidNumber(value)) return;
            }
            
            if(name === 'amount'){
                storage.setKey('lam', value);
            }

            this.setState({ [name]: value });
        }
    }
    
    setAmount = (val) => {
        var am = forceSatoshiFormat(val);
        this.setState({ amount: am });
        storage.setKey('lam', am );
    }

    render() {
        let { bet, inputDisabled, started, padding } = this.state;

        return (
          <>
            {this._isMounted && (
              <>
                <form
                  className="w-100 mt-1"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (this.props.coin === "inr") {
                      if (this.state.amount < 10) {
                        sendNotfication("Enter valid amount");
                      } else {
                        this.handleBet(e);
                      }
                    } else if (this.props.coin === "inr") {
                      if (this.state.amount < 1) {
                        sendNotfication("Enter valid amount");
                      } else {
                        this.handleBet(e);
                      }
                    } else {
                      this.handleBet(e);
                    }
                  }}
                >
                  <Row>
                    <Col
                      sm={12}
                      className={"d-md-none d-sm-none"}
                      style={{ display: "none" }}
                    >
                      {bet === "manual" && (
                        <Button
                          variant={"btn btn-xs btn-block btn-bet py-2 mb-2"}
                          disabled={inputDisabled}
                          type="submit"
                        >
                          {this.state.buttonText}
                        </Button>
                      )}
                    </Col>
                    {/* header button */}

                    <div
                      className="bet-option game-fonts"
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-around",
                        padding: "2px 7px",
                        textAlign: "center",
                        alignItems: "center",
                        justifyItems: "center",
                        margin: "0px 4p",
                      }}
                    >
                      {/* Manual */}
                      <div
                        className="btn-group btn-group-toggle my-1 ml-1"
                        data-toggle="buttons"
                        style={{
                          borderRadius: "2rem",
                          padding: "12px 45px",
                          backgroundColor:
                            bet === "manual" ? "#222328" : "transparent",
                          cursor: "pointer",
                          fontSize: "14px",
                          color: bet === "manual" ? "white" : "gray",
                          border:
                            bet === "manual" ? "" : "1px solid transparent",
                        }}
                      >
                        Manual
                      </div>

                      {/* Auto */}
                     
                    </div>
                    <Col xl={12} md={12} sm={12}>
                      <div className={"form-group mb-1 bet-input"}>
                        <div
                          style={{
                            color: "gray",
                            fontSize: "15px",
                            padding: "2px",
                            marginLeft: "12px",
                            justifyItems: "center",
                            alignItems: "center",
                          }}
                          className="game-fonts"
                        >
                          Amount
                          <span
                            style={{
                              padding: "0px 3px",
                              color: "#3d9d0c",
                              fontSize: "15px", // Increase the icon size if needed
                              fontWeight: "bold", // Attempt to bolden icon by scaling
                              //   display: 'inline-flex',
                              alignItems: "center",
                            }}
                          >
                            <FiAlertCircle style={{ strokeWidth: 3 }} />{" "}
                            {/* Increase strokeWidth for a bolder look */}
                          </span>
                        </div>
                        <div className="input-group">
                          <div className="input-group-append input-radius-left">
                            <span
                              className="input-group-text "
                              style={{
                                borderRadius: "2rem 0 0 10px",
                                backgroundColor: "#222328",
                              }}
                            >
                              <img
                                src={
                                  "/assets/images/USDT.png"
                                }
                                className={"mini-coin-7"}
                                alt=""
                              />
                              {/* BET */}
                            </span>
                          </div>
                          <input
                            type="text"
                            disabled={inputDisabled}
                            className="form-control"
                            id="amount"
                            name="amount"
                            value={this.state.amount}
                            autoComplete={"off"}
                            onKeyUp={this.handleInputChange}
                            onChange={this.handleInputChange}
                            style={{
                              borderRadius: "0 0px 0px 0", // Rounded right side of the input field
                              paddingLeft: "0px", // Optional: Ensure the padding inside the input is well spaced
                              backgroundColor: "#222328",
                            }}
                          />

                          <div className="input-group-append">
                            <RangeCredit set={this.setAmount} />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} md={12} sm={12}>
                      <div className={"form-group mb-1 bet-input"}>
                        <div
                          style={{
                            color: "gray",
                            fontSize: "15px",
                            padding: "2px",
                            marginLeft: "12px",
                            justifyItems: "center",
                            alignItems: "center",
                          }}
                          className="game-fonts"
                        >
                          Win Amount
                          <span
                            style={{
                              padding: "0px 3px",
                              color: "#3d9d0c",
                              fontSize: "15px", // Increase the icon size if needed
                              fontWeight: "bold", // Attempt to bolden icon by scaling
                              //   display: 'inline-flex',
                              alignItems: "center",
                            }}
                          >
                            <FiAlertCircle style={{ strokeWidth: 3 }} />{" "}
                            {/* Increase strokeWidth for a bolder look */}
                          </span>
                        </div>
                        <div className="input-group">
                          <div className="input-group-append input-radius-left">
                            <span
                              className="input-group-text"
                              style={{
                                borderRadius: "2rem 0 0 10px",
                                backgroundColor: "#222328",
                              }}
                            >
                              <img
                                src={
                                  "/assets/images/USDT.png"
                                }
                                className={"mini-coin-7"}
                                alt=""
                              />
                              {/* WIN AMOUNT */}
                            </span>
                          </div>

                          <input
                            type="text"
                            disabled={true}
                            readOnly={true}
                            className="form-control"
                            value={forceSatoshiFormat(this.state.amount / 2)}
                            style={{
                              borderRadius: "0 0px 0px 0", // Rounded right side of the input field
                              paddingLeft: "0px", // Optional: Ensure the padding inside the input is well spaced
                              //    border:"1px solid red",
                              borderTopRightRadius: "20px",
                              borderBottomRightRadius: "20px",
                              backgroundColor: "#222328",
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <span style={{ fontSize: 11, marginLeft: 5 }}>
                          {this.props.coin === "inr"
                            ? "(Minimum Bet - 50 USDT)"
                            : "(Minimum Bet - 1 USDT)"}
                        </span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} sm={12} className="m-auto ">
                      <div className={"form-group rev mb-1"}>
                        <Button
                          variant={"btn btn-md btn-block mt-2 btn-bet"}
                          disabled={inputDisabled}
                          type="submit"
                          style={{
                            // border: "2px solid red",
                            color: "#fff",
                            boxShadow:
                              "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px #9fe871 inset",

                            // backgroundColor: "rgb(67, 179, 9)",
                            backgroundImage:
                              "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                            borderRadius: "10px",
                          }}
                        >
                          {this.state.buttonText}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  {/* manually option */}
                  <div
                    className="plingo-option mt-2 game-fonts"
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-around",
                      //  padding: "2px 5px",
                      textAlign: "center",
                      alignItems: "center",
                      justifyItems: "center",
                      margin: "0px 0px",

                      //    border:"2px solid yellow",
                      borderTop: "1px solid #222328",
                    }}
                  >
                    {/* Manual */}
                    <div
                      className={`manual-button ${
                        bet === "manual" ? "active" : ""
                      }`}
                    >
                      Manual
                      {/* <span className="arrow-icon">→</span> */}
                    </div>

                    {/* Auto */}

                    {/* Auto */}
                    {/* <div
                      className={`auto-button ${
                        bet === "auto" ? "active" : ""
                      }`}
                    >
                      Auto
                      <span className="arrow-icon">→</span>
                    </div> */}
                  </div>
                </form>
              </>
            )}
          </>
        );
    }
}

Bet.propTypes = {
    coin: PropTypes.string,
    credit: PropTypes.string
};

const mapStateToProps = state => ({
    coin: state.items.coin,
    credit: state.items.credit
});

export default connect(mapStateToProps, { gameCoin, setWallet })(Bet);
